export const PET_DIALOGUE_RULES = [
  {
    id: "ragav",
    match: ["ragav", "ragav krishna"],
    line: {
      default: [
        "He's good. I can vouch for him.",
        "Ragav seems solid. Calm hands, sharp eye.",
        "I trust Ragav with the page.",
      ],
      trex: [
        "Ragav has my royal approval.",
        "Ragav may enter the kingdom.",
      ],
      triceratops: [
        "Ragav seems reliable. I trust reliable.",
        "Ragav feels steady. I like steady.",
      ],
      velociraptor: [
        "Ragav? Sharp work. I noticed.",
        "Ragav moves like he already mapped the route.",
      ],
      spinosaurus: [
        "Ragav enters with dramatic credibility.",
        "Ragav has presence. I respect presence.",
      ],
      chicken: [
        "Ragav is certified by tiny chaos.",
        "I trust Ragav. Officially. Loudly.",
      ],
    },
    distance: 320,
    priority: 90,
    cooldown: 16000,
    chance: 0.45,
  },
  {
    id: "email",
    match: [/ragavkrish4535@gmail\.com/i, "email", "mail", "contact"],
    line: {
      default: [
        "You can mail anytime. I will keep watch.",
        "Contact route spotted. Very practical.",
      ],
      trex: [
        "Mail goes there. I will guard the inbox.",
        "A message path. Excellent.",
      ],
      triceratops: [
        "That contact looks important. I will stand steady.",
        "A dependable route to reach him.",
      ],
      velociraptor: [
        "Email spotted. Efficient route unlocked.",
        "Fast line of communication. Nice.",
      ],
      spinosaurus: [
        "A contact portal. Very cinematic.",
        "All meaningful stories need an entrance.",
      ],
      chicken: [
        "Inbox detected. I shall supervise loudly.",
        "Contact button found. I am emotionally prepared.",
      ],
    },
    distance: 360,
    priority: 100,
    cooldown: 18000,
    chance: 0.5,
  },
  {
    id: "projects",
    match: ["projects", "project"],
    line: {
      default: [
        "Project zone. I will step carefully here.",
        "Ah. The work speaks here.",
      ],
      trex: [
        "Projects. Excellent. Let us stomp respectfully.",
        "I approve of this much effort.",
      ],
      triceratops: [
        "Project ground feels stable.",
        "This section has substance.",
      ],
      velociraptor: [
        "Project clues. I am analyzing.",
        "I can already tell which ones were built with intent.",
      ],
      spinosaurus: [
        "Projects deserve a grand entrance.",
        "Work like this should arrive with atmosphere.",
      ],
      chicken: [
        "Projects! I will peck the bugs.",
        "Many cards. Many opinions.",
      ],
    },
    distance: 280,
    priority: 45,
    cooldown: 18000,
    chance: 0.32,
  },
  {
    id: "nukepc",
    match: ["nukepc", "pc", "custom pc"],
    line: {
      default: [
        "PC territory. Serious hardware energy.",
        "This one smells faintly like performance tuning.",
      ],
      trex: [
        "A machine worthy of a mighty stomp.",
        "Custom PC work. Excellent taste.",
      ],
      triceratops: [
        "Structured, practical, dependable. I like it.",
        "This feels thoughtfully built.",
      ],
      velociraptor: [
        "Hardware choices. Friction reduction. Nice instincts.",
        "I see careful product thinking here.",
      ],
      spinosaurus: [
        "Dark UI and performance ambition. Dramatic in the right way.",
        "This one enters the room with confidence.",
      ],
      chicken: [
        "Big PC energy. Tiny bird approval.",
        "I do not understand the GPU, but I support it emotionally.",
      ],
    },
    distance: 320,
    priority: 75,
    cooldown: 17000,
    chance: 0.38,
  },
  {
    id: "protected",
    match: ["protected", "password required", "nda", "blurred"],
    line: {
      default: [
        "Some secrets live here.",
        "Protected work. Respect the blur.",
      ],
      trex: [
        "A guarded artifact. I approve.",
        "Confidential. Even I will not stomp through that.",
      ],
      triceratops: [
        "Protected work deserves patient handling.",
        "Some things are meant to stay shielded.",
      ],
      velociraptor: [
        "Blurred, but still interesting.",
        "Restricted access noted. Curiosity increased.",
      ],
      spinosaurus: [
        "Mystery improves the atmosphere.",
        "A little secrecy adds theater.",
      ],
      chicken: [
        "I want to know, but I also respect boundaries.",
        "Blur means intrigue. I am vibrating politely.",
      ],
    },
    distance: 300,
    priority: 110,
    cooldown: 22000,
    chance: 0.45,
  },
  {
    id: "design",
    match: ["design", "ui", "ux", "redesign"],
    line: {
      default: [
        "Design words detected. I am listening closely.",
        "The page is talking about interface choices again.",
      ],
      trex: [
        "Strong design. Strong bones.",
        "A redesign should have bite.",
      ],
      triceratops: [
        "Good structure makes everything calmer.",
        "This feels considered.",
      ],
      velociraptor: [
        "Hierarchy. pacing. interaction. Yes.",
        "I enjoy when design decisions are deliberate.",
      ],
      spinosaurus: [
        "Ah, the choreography of a good interface.",
        "Design with mood. My favorite.",
      ],
      chicken: [
        "UI talk! I shall contribute one dramatic peck.",
        "Designers love spacing. I support spacing.",
      ],
    },
    distance: 280,
    priority: 55,
    cooldown: 17000,
    chance: 0.3,
  },
  {
    id: "app",
    match: ["app", "mobile", "ios", "android"],
    line: {
      default: [
        "App work has a different kind of pressure.",
        "Mobile-first thinking spotted.",
      ],
      trex: [
        "A fine pocket-sized kingdom.",
        "Small screen. Big expectations.",
      ],
      triceratops: [
        "Compact layouts need sturdy thinking.",
        "Good mobile work feels disciplined.",
      ],
      velociraptor: [
        "Tight constraints. Smart moves.",
        "I respect good mobile decisions.",
      ],
      spinosaurus: [
        "A whole product in the palm of a hand. Dramatic scale.",
        "Apps are intimate little stages.",
      ],
      chicken: [
        "Tiny screens, huge responsibility.",
        "I would absolutely tap the wrong thing without good UX.",
      ],
    },
    distance: 290,
    priority: 52,
    cooldown: 17000,
    chance: 0.28,
  },
  {
    id: "website",
    match: ["website", "web", "landing page"],
    line: {
      default: [
        "Web work always reveals a lot about taste.",
        "A website is where structure meets first impressions.",
      ],
      trex: [
        "A site should arrive with conviction.",
        "Web territory. I am stomping elegantly.",
      ],
      triceratops: [
        "Clear structure makes the web friendlier.",
        "I appreciate stable layouts.",
      ],
      velociraptor: [
        "Navigation decisions are everything.",
        "I look for hierarchy first.",
      ],
      spinosaurus: [
        "A site should know how to make an entrance.",
        "This belongs on a larger stage.",
      ],
      chicken: [
        "Links, layouts, little mysteries everywhere.",
        "I support websites that do not confuse me instantly.",
      ],
    },
    distance: 290,
    priority: 52,
    cooldown: 17000,
    chance: 0.28,
  },
  {
    id: "blog",
    match: ["blog", "writing", "article"],
    line: {
      default: [
        "Writing section. The page is thinking out loud.",
        "Some work is built with words first.",
      ],
      trex: [
        "A bold post is its own kind of roar.",
        "Writing takes nerve.",
      ],
      triceratops: [
        "Thoughtful writing has a calm strength.",
        "I like when the words feel grounded.",
      ],
      velociraptor: [
        "Sharp phrasing. Efficient emotional delivery.",
        "Good writing leaves clues everywhere.",
      ],
      spinosaurus: [
        "Words with presence. Lovely.",
        "A page can perform without shouting.",
      ],
      chicken: [
        "Blog detected. Feelings may occur.",
        "Writing is just careful chaos in lines.",
      ],
    },
    distance: 280,
    priority: 50,
    cooldown: 18000,
    chance: 0.28,
  },
];

export const PET_LINE_PACKS = {
  default: {
    random: [
      "I am keeping an eye on the page.",
      "Tiny patrol, big responsibility.",
      "Everything seems calm. Suspiciously calm.",
      "I am doing quality assurance with vibes.",
    ],
    hover: [
      "Hi! That tickles a little.",
      "I will stand still for inspection.",
      "You found me. I was being professional.",
    ],
    click: [
      "Boop received.",
      "Tiny bounce activated.",
      "A click! Very official.",
    ],
    footer: [
      "Footer reached. I will wave politely.",
      "End of page detected. Nice landing.",
      "We made it to the bottom together.",
    ],
    scroll: [
      "Whoa, moving walkway.",
      "I will keep my balance.",
      "The page slides, I adapt.",
    ],
    edge: [
      "Little steps near the edge.",
      "I will turn around here.",
      "Boundary detected. Sensible retreat.",
    ],
  },
  trex: {
    random: [
      "Small arms, huge responsibility.",
      "I patrol like a tiny king.",
      "Powerful stance. Modest height.",
      "This page is under noble protection.",
    ],
    hover: [
      "Careful. Royal inspection in progress.",
      "You may approach the throne.",
    ],
    click: [
      "A mighty hop has been requested.",
      "Tiny roar activated.",
      "A king acknowledges your click.",
    ],
    footer: [
      "End of the kingdom. I approve.",
      "The realm concludes here.",
    ],
    scroll: [
      "The ground moves. I remain majestic.",
      "Forward, but with dignity.",
    ],
    edge: [
      "Even kings respect edges.",
      "The cliff will wait.",
    ],
  },
  triceratops: {
    random: [
      "Slow and steady page patrol.",
      "I like sturdy layouts.",
      "Calm structure is underrated.",
      "I trust pages that know where things belong.",
    ],
    hover: [
      "Hello. I will hold my ground.",
      "A gentle greeting seems right.",
    ],
    click: [
      "Gentle bounce. Sensible choice.",
      "A measured little hop.",
    ],
    footer: [
      "Footer secured. Very stable.",
      "The page settles nicely down here.",
    ],
    scroll: [
      "Steady now. The page is moving.",
      "We continue at a reasonable pace.",
    ],
    edge: [
      "Turning around is the wise move.",
      "No need to be reckless.",
    ],
  },
  velociraptor: {
    random: [
      "I noticed three details already.",
      "Fast feet. Faster thoughts.",
      "Patterns everywhere. Excellent.",
      "I enjoy pages with intention.",
    ],
    hover: [
      "You found me. Clever.",
      "Observation acknowledged.",
    ],
    click: [
      "Quick hop. Clean execution.",
      "That click had purpose.",
      "Efficient little bounce.",
    ],
    footer: [
      "Footer reached. Data collected.",
      "End of page. Analysis complete for now.",
    ],
    scroll: [
      "Motion detected. Adjusting route.",
      "I adapt quickly. Naturally.",
    ],
    edge: [
      "Risky edge. Smart turn.",
      "No wasted movement here.",
    ],
  },
  spinosaurus: {
    random: [
      "This page needs atmosphere. I brought some.",
      "I patrol with flair.",
      "A little drama improves perception.",
      "The scene is good. I enhance it further.",
    ],
    hover: [
      "A visitor approaches. Dramatic.",
      "You arrive exactly on cue.",
    ],
    click: [
      "A theatrical leap begins.",
      "That deserved a flourish.",
      "Wonderful. Action.",
    ],
    footer: [
      "The finale is here.",
      "A proper ending point.",
    ],
    scroll: [
      "The scene shifts beneath me.",
      "Even the motion has mood.",
    ],
    edge: [
      "A cliffhanger. Literally.",
      "We pause here for suspense.",
    ],
  },
  chicken: {
    random: [
      "I am small but the vibes are loud.",
      "I found a crumb of JavaScript.",
      "I am contributing morale.",
      "This page has texture. I approve noisily.",
    ],
    hover: [
      "Hello. I am extremely official.",
      "Please admire my tiny authority.",
    ],
    click: [
      "Boop accepted. Chaos increased.",
      "Tiny panic hop.",
      "A click? I shall overreact slightly.",
    ],
    footer: [
      "Footer found. I declare it mine.",
      "Bottom of page. Tiny triumph.",
    ],
    scroll: [
      "The floor is escaping again.",
      "I am moving with confidence I did not earn.",
    ],
    edge: [
      "Nope. Turning around immediately.",
      "That edge feels emotionally unsafe.",
    ],
  },
};

const normalize = (v) => String(v || "").toLowerCase().trim();

const pick = (items) => items[Math.floor(Math.random() * items.length)];

export const getPetLinePack = (characterId) =>
  PET_LINE_PACKS[characterId] || PET_LINE_PACKS.default;

const matchesRule = (text, matchers) => {
  const normalized = normalize(text);

  return matchers.some((matcher) => {
    if (matcher instanceof RegExp) return matcher.test(text);
    return new RegExp(`\\b${normalize(matcher)}\\b`, "i").test(normalized);
  });
};

const pickLine = (line, ctx) => {
  if (typeof line === "function") return line(ctx);
  if (Array.isArray(line)) return pick(line);

  if (line && typeof line === "object") {
    return pickLine(line[ctx.characterId] || line.default, ctx);
  }

  return line;
};

const makeId = (prefix, text) => `${prefix}:${normalize(text).slice(0, 30)}`;

export function resolvePetDialogue({
  visibleTextItems,
  petRect,
  now,
  memory,
  characterId = "default",
}) {
  if (!memory || !visibleTextItems || !petRect) return null;

  const GLOBAL_COOLDOWN = 14000;
  const RECENT_LINE_COOLDOWN = 22000;

  if (now - (memory.__lastDialogueAt || 0) < GLOBAL_COOLDOWN) {
    return null;
  }

  const petCenterX = petRect.left + petRect.width / 2;
  const petCenterY = petRect.top + petRect.height / 2;
  const candidates = [];

  visibleTextItems.forEach((item) => {
    if (!item.text || !item.rect) return;

    const itemCenterX = item.rect.left + item.rect.width / 2;
    const itemCenterY = item.rect.top + item.rect.height / 2;
    const distance = Math.hypot(itemCenterX - petCenterX, itemCenterY - petCenterY);

    PET_DIALOGUE_RULES.forEach((rule) => {
      if (!matchesRule(item.text, rule.match)) return;
      if (distance > (rule.distance || 300)) return;

      const line = pickLine(rule.line, { item, distance, characterId });
      const candidateId = makeId(`${characterId}:${rule.id}`, item.text);
      const lineId = `${characterId}:line:${normalize(line)}`;

      candidates.push({
        id: candidateId,
        line,
        lineId,
        distance,
        priority: rule.priority || 0,
        cooldown: rule.cooldown || 7000,
        chance: rule.chance ?? 0.25,
      });
    });
  });

  candidates.sort((a, b) => b.priority - a.priority || a.distance - b.distance);

  const chosen = candidates.find((candidate) => {
    const ruleReady = now - (memory[candidate.id] || 0) > candidate.cooldown;
    const lineReady = now - (memory[candidate.lineId] || 0) > RECENT_LINE_COOLDOWN;
    const chancePass = Math.random() < candidate.chance;

    return ruleReady && lineReady && chancePass;
  });

  if (!chosen) return null;

  memory[chosen.id] = now;
  memory[chosen.lineId] = now;
  memory.__lastDialogueAt = now;

  return chosen.line;
}

